import Container from 'react-bootstrap/Container';
import {get} from "../../helpers/httpClient";
import {useParams} from "react-router-dom";
import {useState, useEffect} from "react";

function PrivacyPolicy() {
    const { gym } = useParams();
    const [gymInfo, setGym] = useState(null)

    const getInfo = () => {
        get('gyms/' + gym + '/legal-info').then((resp) => {
                setGym(resp.gym)
        }).catch(() => {})
    }

    useEffect(() => {
        getInfo()
    })

    return (
        <Container className="mt-5">
                {gymInfo !== null &&
                <div className="privacy-container">
                        <h1>Политика приватности за { gymInfo.name } и gyms.rs</h1>

                        <div className="effective-date">Датум ступања на снагу: <span id="current-date">2025 jan, 25</span></div>

                        <h2>1. Увод</h2>
                        <p><strong>{ gymInfo.name } и gyms.rs</strong>,
                                поштује вашу приватност и обавезује се да заштити ваше личне податке у складу са
                                законским прописима Републике Србије, укључујући <strong>Закон о заштити података о
                                        личности</strong> («Службени гласник РС», бр. 87/2018).</p>
                        <p>Ова Политика приватности објашњава како прикупљамо, користимо, чувамо и штитимо ваше податке
                                када користите наш сајт.</p>

                        <h2>2. Које податке прикупљамо?</h2>
                        <p>Можемо прикупити следеће податке:</p>
                        <ul>
                                <li><strong>Лични подаци</strong>: име, презиме, е-адреса, телефон, датум рођења, адреса
                                        (ако је потребно за чланство).
                                </li>
                                <li><strong>Подаци о плаћању</strong>: информације о картици или другим начинима плаћања
                                        (обрађују се преко осигураних платних система).
                                </li>
                                <li><strong>Технички подаци</strong>: IP адреса, тип прегледача, колачићи (cookies),
                                        историја посета.
                                </li>
                                <li><strong>Подаци о здрављу</strong> (ако су потребни за тренинг): информације о
                                        здравственом стању, нивоу физичке спремности (прикупљају се само са вашим
                                        пристанком).
                                </li>
                        </ul>

                        <h2>3. Како користимо ваше податке?</h2>
                        <p>Ваши подаци се могу користити за:</p>
                        <ul>
                                <li>Регистрацију и управљање вашим налогом.</li>
                                <li>Обраду плаћања и резервацију услуга.</li>
                                <li>Слање обавештења, промоција и новости (само са вашим пристанком).</li>
                                <li>Побољшање рада сајта и анализу посећености.</li>
                                <li>Обезбеђивање безбедности и спречавање превара.</li>
                        </ul>

                        <h2>4. Правни основ обраде података</h2>
                        <p>Обрада података се врши на основу:</p>
                        <ul>
                                <li>Вашег пристанка (за слање новости, података о здрављу).</li>
                                <li>Уговорне обавезе (пружање услуга теретане).</li>
                                <li>Легитимног интереса (анализа саобраћаја, безбедност).</li>
                        </ul>

                        <h2>5. Кому прослеђујемо податке?</h2>
                        <p>Ваши подаци се могу проследити:</p>
                        <ul>
                                <li>Партнерима и пружаоцима услуга (платни системи, хостинг).</li>
                                <li>Државним органима (само по законском захтеву).</li>
                                <li>Трећим лицима само са вашим пристанком.</li>
                        </ul>

                        <h2>6. Заштита података</h2>
                        <p>Користимо техничке и организационе мере (енкрипција, ограничен приступ) да бисмо заштитили
                                ваше податке од губитка, крађе или неовлашћеног приступа.</p>

                        <h2>7. Ваша права</h2>
                        <p>Имате право да:</p>
                        <ul>
                                <li>Затражите приступ, исправку или брисање ваших података.</li>
                                <li>Одустанете од пристанка на обраду.</li>
                                <li>Поднесете жалбу <strong>Поверенику за информације од јавног значаја и заштиту
                                        података о личности</strong> (<a href="https://www.poverenik.rs" rel="noreferrer"
                                                                         target="_blank">www.poverenik.rs</a>).
                                </li>
                        </ul>

                        <h2>8. Колачићи (Cookies) и сличне технологије</h2>
                        <p>Користимо колачиће за функционалност сајта и аналитику. Можете их онемогућити у поставкама
                                прегледача, али то може утицати на коришћење сајта.</p>

                        <h2>9. Измене Политике приватности</h2>
                        <p>Можемо ажурирати ову Политику. Тренутна верзија ће увек бити доступна на сајту.</p>

                        <div className="contact-info">
                                <h2>10. Контакт</h2>
                                <p>За питања о заштити података, контактирајте нас:</p>
                                <ul>
                                        <li><strong>Адреса:</strong> { gymInfo.address }</li>
                                        <li><strong>Телефон:</strong> { gymInfo.phone }</li>
                                </ul>
                        </div>
                </div>
                }
        </Container>
    );
}

export default PrivacyPolicy;